/*
     dispatch(setApiError({
            name: api names,
            data: {
                heading: heading Content,
                content: text content
            }
        }));
        default warning image will be shown for errro
        pass isPopup false if dont want to show popup
        dont pass data for default error popup
     dispatch(setApiSuccess({
        name: 'SHARED', popup image will be based on this value
        isPopup: true,
        data: {
            heading: data.popUp.heading,
            content: data.popUp.text
        }
    }));

    show success popup
*/

import React, { useCallback } from 'react';

import Modal from '../../../common/Modal/Modal';
import * as ErrorStyle from './StatusPopupStyles';
import { GenericP } from '../../../common/Styles';
import { PATHS } from '../../../AppConstants';
import { ASSET_PATH } from '../../../../assetsPath';
import TimerFooter, { redirectAction } from '../../../common/TimerFooter/TimerFooter';
import { ERROR_HEADING, ERROR_CONTENT } from '../../config';

const timeOut = 10;

const Footer = () => ( <ErrorStyle.Footer>
	<TimerFooter redirectTime={timeOut} redirectionUrl={PATHS.MYBIZ_URL} />
                       </ErrorStyle.Footer>
);

const imgPaths = {
	'SHARED': ASSET_PATH.IMAGES + 'cartFooter/cartfooter.png',
	'SHARED_ITIN': ASSET_PATH.IMAGES + 'cartFooter/cartfooter.png',
	'REQ_CANCELLED': ASSET_PATH.IMAGES + 'shortlist/bgGreentick.png',
	'SUCCESS': ASSET_PATH.IMAGES + 'shortlist/bgGreentick.png',
	'ERR_DEFAULT': ASSET_PATH.IMAGES + 'shortlist/attention.png'
};

const popupSize = {
	'SHARED': '720px',
	'SHARED_ITIN': '720px',
	'ERR_DEFAULT': '500px',
	'REQ_CANCELLED': '500px',
	'SUCCESS': '500px'
};

const styleImg = {
	'SHARED': 'cartSucess',
	'SHARED_ITIN': 'cartSucess',
	'REQ_CANCELLED': 'bgtick',
	'SUCCESS': 'bgtick',
	'ERR_DEFAULT': 'errorImg'
};

const showFooter = {
	'SHARED': true,
	'REQ_CANCELLED': true,
	'SHARED_ITIN': true,
	'ERROR': true
};

const StatusPopup = ({ heading = false, content = false, handleModal, apiSuccess, btnType, btnWidth }) => {
	const imgUrl = apiSuccess ? imgPaths[apiSuccess] : imgPaths['ERR_DEFAULT'];
	const imgStyle = apiSuccess ? styleImg[apiSuccess] : styleImg['ERR_DEFAULT'];
	const size = apiSuccess ? popupSize[apiSuccess] : popupSize['ERR_DEFAULT'];
	const showModalFooter = apiSuccess ? showFooter[apiSuccess] : showFooter['ERR_DEFAULT'];
	const data = {
		img: imgUrl || imgPaths['ERR_DEFAULT'],
		imgStyle: imgStyle || styleImg['ERR_DEFAULT'],
		title: heading || ERROR_HEADING,
		titleAlign: 'center',
		customClass: 'shortlisterror'
	};

	const contentText = (content || ERROR_CONTENT);

	const handleModalClick = useCallback(() => {
		if (showModalFooter) {
			redirectAction(PATHS.MYBIZ_URL);
		} else {
			handleModal();
		}
	}, []);

	return (
		<Modal
			close={false}
			$width={size || popupSize['ERR_DEFAULT']}
			imgWidth='60px'
			imgHeight='54px'
			Modaldata={data}
			handleModal={handleModalClick}
			btnTxt='OK'
			btnType={btnType || 'Capsule'}
			btnName='Primary'
			btnWidth={btnWidth || '130px'}
			handleClick={handleModalClick}
			footer={showModalFooter ? <Footer /> : ''}>
			{contentText && <GenericP bottom_M='80' text_align='center' dangerouslySetInnerHTML={{ __html: contentText }} />}
		</Modal>
	);
};

export default StatusPopup;
